import { render, staticRenderFns } from "./moblie.vue?vue&type=template&id=65637876&scoped=true"
import script from "./moblie.vue?vue&type=script&lang=js"
export * from "./moblie.vue?vue&type=script&lang=js"
import style0 from "./moblie.vue?vue&type=style&index=0&id=65637876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65637876",
  null
  
)

export default component.exports